import React from 'react';

import I18n from 'utils/I18n';
import Cldr from 'utils/Cldr';
import clsx from '@strava/ui/clsx';

import { useCheckoutContext } from '../../../state/CheckoutContext';
import { getTrialProduct } from '../../../state/Checkout.actions';
import { getStyles as _getStyles } from '../../../utils/checkoutUtils.js';
import { I18nPrefixOrganic } from '../../../shared/constants';

import PromoButton from './PromoButton';
import PromoCodeInput from '../PricingList/PromoCodeInput';

import styles from './Footer.scss';

export const Footer = () => {
  const { checkoutEntityState, dispatch } = useCheckoutContext();

  const {
    experiments,
    isTrialEligible,
    pricing,
    products,
    promoCodeInputVisibility: isPromoCodeInputVisible
  } = checkoutEntityState;
  const promotionApplied = !!products?.promotion?.code;
  const { currency, billedToday } = pricing;
  const { shouldShowCheckoutRefresh } = experiments;

  const getStyles = (style) =>
    _getStyles(styles, style, shouldShowCheckoutRefresh);

  const shouldShowBilledToday = !shouldShowCheckoutRefresh;
  // only render `·` divider if both buttons (styled as hyperlinks) are present
  let shouldShowPromoButton = !isPromoCodeInputVisible;
  if (promotionApplied && shouldShowCheckoutRefresh) {
    // don't show "Remove promo code" btn since we use RemovePromoIcon in this case
    shouldShowPromoButton = false;
  }
  const shouldShowMoreBillingButton = isTrialEligible;
  const shouldShowDivider =
    shouldShowPromoButton && shouldShowMoreBillingButton;
  const shouldShowPromoInput =
    !promotionApplied && isPromoCodeInputVisible && shouldShowCheckoutRefresh;

  return (
    <div className={styles.summaryFooter}>
      {shouldShowBilledToday && (
        <div className={styles.billedToday}>
          <div className={styles.billed}>
            <strong>{I18n.t(`${I18nPrefixOrganic}.billed_today`)}</strong>
          </div>
          <div className={styles.billedTotal} data-testid="footer_billed_today">
            <strong>{Cldr.formatCurrency(billedToday, currency)}</strong>
          </div>
        </div>
      )}
      {shouldShowPromoInput && (
        <div className={styles.promoInput}>
          <PromoCodeInput />
        </div>
      )}
      <div className={clsx(getStyles('footerActions'))}>
        {shouldShowPromoButton && <PromoButton />}
        {shouldShowDivider && <span className={styles.actionDivider}>·</span>}
        {shouldShowMoreBillingButton && (
          <button
            className={clsx(
              'btn',
              'btn-link',
              styles.actionButton,
              getStyles('moreBillingOptions')
            )}
            onClick={() => getTrialProduct(checkoutEntityState, dispatch)}
            type="button"
          >
            {I18n.t(`${I18nPrefixOrganic}.cta.redeem_trial_offer`)}
          </button>
        )}
      </div>
    </div>
  );
};

export default Footer;
